import { Injectable } from 'injection-js';
import { Element } from 'shared/core';
import { Toasts } from 'shared/lib';

@Injectable()
export class CopyToClipboardElement extends Element {
  constructor() {
    super();
  }

  public init(): void {
    $('body').on('click', '.copy-to-clipboard', event => this.copyToClipboard(event));
    $('body').on('click', '[data-copy-source]', event => this.copyFromSource(event));
  }

  private async copyToClipboard(event: JQuery.ClickEvent): Promise<void> {
    event.preventDefault();
    let copyText = document.createElement('textarea');
    copyText.value = $(event.target).closest('.copy-to-clipboard').data('value');
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    Toasts.addToast('Copied to Clipboard', 'notice');
  }

  private copyFromSource(event: JQuery.ClickEvent): void {
    event.preventDefault();
    const selector = $(event.currentTarget).data('copy-source');
    const copyText = document.createElement('textarea');
    copyText.value = $(selector).text();
    document.body.appendChild(copyText);
    copyText.select();
    document.execCommand('copy');
    document.body.removeChild(copyText);
    Toasts.addToast('Copied to Clipboard', 'notice');
  }
}
